<template>
  <div class="select-startstop">
    <section class="title-bar">
      <div class="hero-body">
        <p class="title">作業内容の選択</p>
        <p class="subtitle">作業内容を選択してください</p>
      </div>
    </section>

    <div class="block"></div>
    <div v-for="(row, row_index) in work_rows" :key="row.id" class="container">
      <div class="tile is-ancestor">
        <div
          v-for="(work, col_index) in row"
          :key="work"
          @click="select_work_clicked(row_index, col_index)"
          class="tile is-parent is-3"
        >
          <article
            class="tile is-child notification is-success"
            :class="{ 'is-warning': index % 2 === 0 }"
          >
            <p class="title">{{ work }}</p>
          </article>
        </div>
      </div>
    </div>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
      style="background-color: rgba(0, 0, 0, 0.8)"
    ></b-loading>
  </div>
</template>

<script>
import ApiService from '../services/ApiService';

export default {
  name: 'SelectWork',
  data: function () {
    return {
      action: '',
      place: '',
      works: [],
      work_rows: [[]],
      isLoading: false,
    };
  },
  watch: {
    works: function (newValue, oldValue) {
      var rows = [];
      var row = [];
      //表示上、4つの要素毎に、containerを追加して改行するために、リストを分割する
      newValue.forEach((element, index) => {
        row.push(element);
        if (index % 4 == 3) {
          rows.push(row);
          row = [];
        }
      });
      if (row.length !== 0) {
        rows.push(row);
      }
      this.work_rows = rows;
    },
  },
  mounted() {
    if (
      !(this.$route.query.action == 'start' || this.$route.query.action == 'end') &&
      this.$route.query.pid
    ) {
      this.$buefy.dialog.alert({
        message: '不正な遷移です。最初からやり直してください。',
        onConfirm: () => {
          this.$router.push('/login');
        },
      });
    }
    this.action = this.$route.query.action;
    this.placeName = this.$route.query.pname;
    this.uid = this.$route.query.uid;

    // 作業場所一覧の取得
    const apiService = new ApiService();

    const me = this;

    this.isLoading = true;

    apiService.getTaskList((response) => {
      this.isLoading = false;
      if (response.status == 200) {
        const workResult = response.data?.result?.task_name_list;
        // リスト文字列をリストに変換
        this.works = workResult.replace('[', '').replace(']', '').split(',');
      } else if (response.status == 401) {
        // トークン再取得失敗時にはログイン画面へ遷移
        me.$buefy.dialog.alert({
          message: 'ログインに失敗しました、管理者に再度ログインしてもらってください。',
          onConfirm: () => {
            this.$router.push('/admin_login');
          },
        });
      }
    });
  },
  methods: {
    select_work_clicked: function (row_index, col_index) {
      const taskName = this.work_rows[row_index][col_index];
      if (this.action == 'start') {
        this.$buefy.dialog.confirm({
          message: '作業開始を記録します',
          onConfirm: () => {
            this.save_work_record(taskName);
          },
        });
      } else {
        this.$router.push(
          `/input_amount?action=${this.action}&uid=${this.uid}&pname=${this.placeName}&tname=${taskName}`
        );
      }
    },
    save_work_record: function (taskName) {
      const record = {
        worker_id: this.uid,
        task_name: taskName,
        result: '',
        working_area_name: this.placeName,
        record_type: this.action,
      };

      const apiService = new ApiService();

      this.isLoading = true;

      apiService.saveWorkingRecord(record, (response) => {
        this.isLoading = false;
        if (response.status == 200) {
          this.$buefy.toast.open('作業の記録を行いました');
          setTimeout(() => {
            this.$router.push('/done');
          }, 1000);
        } else if (response.status == 401) {
          // トークン再取得失敗時にはログイン画面へ遷移
          this.$buefy.dialog.alert({
            message: 'ログインに失敗しました、管理者に再度ログインしてもらってください。',
            onConfirm: () => {
              this.$router.push('/admin_login');
            },
          });
        } else {
          this.$buefy.alert('作業記録の送信に失敗しました');
        }
      });
    },
  },
};
</script>

<style scoped>
section.title-bar {
  background-color: #008a75;
}
p.title {
  color: white;
}
p.subtitle {
  color: white;
}

article.tile.is-child.notification.is-success {
  background-color: #ff7d00;
  border-radius: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/SelectWork.vue